import { render, staticRenderFns } from "./CellphoneInput.vue?vue&type=template&id=3ded8209&"
import script from "./CellphoneInput.vue?vue&type=script&lang=js&"
export * from "./CellphoneInput.vue?vue&type=script&lang=js&"
import style0 from "./CellphoneInput.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports